import { useContext } from 'react';
import { NotificationContext } from './NotificationContext';
export var useNotificationContext = function () { return useContext(NotificationContext); };
//# sourceMappingURL=useNotificationContext.js.map